module.exports = __webpack_public_path__ + "img/discount15.ad298795.png";